export const ill1 = require('./ill1.png');
export const ill2 = require('./ill2.png');
export const ill3 = require('./ill3.png');
export const ill4 = require('./ill4.png');
export const ill5 = require('./ill5.png');
export const ill5_mobile = require('./ill5_mobile.png');
export const ill2_mobile = require('./ill2_mobile.png');
